import { UseFormReturn } from "react-hook-form";
import { ModuleTypeId } from "../../types/DBTables";
import TextEditor from "../Global/Editors/TextEditor";
import { extactModuleOrDefault } from "../Global/ModuleHelpers";
import { useGlobalData } from "../GlobalDataProvider";
import SelectEditor from "../Global/Editors/SelectEditor";
import NumberEditor from "../Global/Editors/NumberEditor";
import { DTOBuilding } from "../../types/building";
import { IModuleByggnadsdata } from "../../types/ModuleDatas";
import { nameof } from "../Global/Utils";
import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { MapTooltip } from "../../types/globalData";
import { watch } from "fs";
import { get } from "../../modules/server";

interface IProps {
  building: DTOBuilding;
  formHook: UseFormReturn;
  remainingArea: number;
  onAddOmråde: (mid: number, område: string) => void;
}

const WizardPage1 = ({ building, formHook, remainingArea, onAddOmråde }: IProps) => {
  const globalData = useGlobalData();
  //const watch = formHook.watch;

  const kommuner = globalData.data ? globalData.data.Gemensamt.Kommuner.map((r) => r.Kommun) : [];
  kommuner.splice(0, 0, "");

  let mByggnadsdata = extactModuleOrDefault(building.modules, ModuleTypeId.Byggnadsdata);
  let mId = mByggnadsdata.id;

  const buildingDatas =
    globalData.buildings?.reduce((acc, b) => {
      const m = b.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      if (m) acc.push(JSON.parse(m.data));
      return acc;
    }, [] as any[]) ?? [];

  const uniqueOmråden: string[] =
    buildingDatas.reduce((acc, bd) => {
      if (bd.område) {
        if (!acc.includes(bd.område)) acc.push(bd.område as string);
      }
      return acc;
    }, [] as string[]) ?? ([] as string[]);

  //const byggArea = watch(mId + ".data." + nameof<IModuleByggnadsdata>("byggnadArea"));
  //const remainingArea = subscriptionParams.TotalSurfaceArea - (subscriptionParams.TotalSurfaceAreaCurrent - subscriptionParams.ThisBuildingArea) - (byggArea ? byggArea : 0);

  return (
    <>
      {/* <h3 className="mb-0">Beskrivning</h3>
      <div className="mb-4 p-1">
        Detta är en beskrivning av byggnaden. Här lägger du till basinformation och vilka system som finns i byggnaden. Konfigurering av varje system görs under konfigurering i ett
        senare steg. Det går att lägga till flera system av samma typ. Det går även att lägga till flera system av olika typ. Varje
      </div> */}

      <div className="row ml-0 pt-4">
        <div className="col-lg-12">
          <TextEditor
            label="Byggnadens namn"
            fieldName={"building.namn"}
            formHook={formHook}
            tooltipId={""} //nameof<MapTooltip>("byggnadsdata_namn")}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange byggnadens namn" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-12">
          <TextEditor
            label="Område"
            fieldName={mId + ".data." + nameof<IModuleByggnadsdata>("område")}
            formHook={formHook}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_område")}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange område" : undefined;
                },
              },
            }}
          >
            <div className="dropdown">
              <Button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
                Hämta område
              </Button>
              {/* <Button type="button" className="gy-0 dropdown-item" onClick={() => onAddOmråde(mId, o)}>
                </Button> */}
              <ul className="dropdown-menu">
                {uniqueOmråden.map((o, index) => (
                  <li key={index} className="dropdown-item" onClick={() => onAddOmråde(mId, o)}>
                    {o}
                  </li>
                ))}
              </ul>
            </div>
          </TextEditor>
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">{"Kvarstående area i abonnemang: " + remainingArea}</div>
        <div className="col-lg-12">
          <NumberEditor
            label="Byggnadsarea"
            fieldName={mId + ".data." + nameof<IModuleByggnadsdata>("byggnadArea")}
            tooltipId={nameof<MapTooltip>("Byggnadsdata_byggnadArea")}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange byggnadsarea" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      {/* <div className="row ml-0">
        <div className="col-lg-12">
          <TextEditor label="Företag" fieldName={mId + ".data.foretag"} formHook={formHook} />
        </div>
      </div> */}

      {/* <div className="row ml-0">
        <div className="col-lg-12">
          <TextEditor label="Område" fieldName={mId + ".data." + nameof<IModuleByggnadsdata>("område")} formHook={formHook} />
        </div>
      </div> */}

      {/* <h4 className="mt-4">Ytterligare information. Inte mandatoriskt att fylla i i detta steg</h4> */}
      {/* <Card.Title className="pt-3">Ytterligare information. Inte mandatoriskt att fylla i i detta steg</Card.Title>
      <div className="row ml-0">
        <div className="col-lg-12">
          <TextEditor label="Adress" fieldName={mId + ".data.adress"} formHook={formHook} />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-6">
          <TextEditor label="Postnummer" fieldName={mId + ".data.postnummer"} formHook={formHook} />
        </div>
        <div className="col-lg-6">
          <TextEditor label="Ort" fieldName={mId + ".data.ort"} formHook={formHook} />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <SelectEditor
            label="Kommun"
            fieldName={mId + ".data.kommun"}
            formHook={formHook}
            items={kommuner}
            // options={{
            //   validate: {
            //     required: (v) => {
            //       return !v ? "Ange kommun" : undefined;
            //     },
            //   },
            // }}
          />
        </div>
      </div> */}

      {/* <div className="row ml-0">
        <div className="col-lg-6">
          <SelectEditor
            label="Verksamhet"
            fieldName={mId + ".data.verksamhet"}
            formHook={formHook}
            items={verksamheter}
            options={{
              validate: {
                // required: (v) => {
                //   return !v ? "Ange verksamhet" : undefined;
                // },
              },
            }}
          />
        </div>
        <div className="col-lg-6">
          <SelectEditor
            label="Nybyggnadsår"
            fieldName={mId + ".data." + nameof<IModuleByggnadsdata>("nybyggnadsår")}
            formHook={formHook}
            items={nybyggnadsÅr}
            options={{
              validate: {
                // required: (v) => {
                //   return !v ? "Ange nybyggnadsår" : undefined;
                // },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0">
        <div className="col-lg-12">
          <SelectEditor
            label="Huvudsaklig energikälla för central uppvärmning"
            fieldName={mId + ".data." + nameof<IModuleByggnadsdata>("energikälla")}
            formHook={formHook}
            items={energikällor}
            options={{
              validate: {
                // required: (v) => {
                //   return !v ? "Ange huvudsaklig energikälla" : undefined;
                // },
              },
            }}
          />
        </div>
      </div> */}
    </>
  );
};

export default WizardPage1;
